var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useAuthProvider } from '#context';
import { useCurrentMemberByWorkspaceId, useFilespaceListByWorkspaceId, useMembersByWorkspaceId, useWorkspaceByIdPoll, } from '#query-hooks';
export const useCheckOnboarding = () => {
    _react_refresh_temp_1();
    const { workspaceId = '' } = useParams();
    const { currentUser } = useAuthProvider();
    const isAuthenticated = Boolean(currentUser);
    const { query: { data: memberData, isError: isErrorMemberData, isPending: isPendingMemberData, }, } = useCurrentMemberByWorkspaceId(workspaceId);
    const { query: { data: workspaceData, isError: isErrorWorkspaceData, isPending: isPendingWorkspaceData, }, } = useWorkspaceByIdPoll(workspaceId);
    const { query: { data: filespacesData, isError: isErrorFilespacesData, isPending: isPendingFilespacesData, }, } = useFilespaceListByWorkspaceId(workspaceId);
    const { 
    // Includes joined members and pending invite members
    query: { data: workspaceMembers, isError: isErrorWorkspaceMembers, isPending: isPendingWorkspaceMembers, }, } = useMembersByWorkspaceId({
        workspaceId,
        withGroups: true,
    });
    const hasOnboardingPrivileges = useMemo(() => {
        if (memberData) {
            return memberData.privileges.onboarding;
        }
        return false;
    }, [memberData]);
    const hasMembers = useMemo(() => Boolean(workspaceMembers && workspaceMembers.length > 1), [workspaceMembers]);
    if (isErrorMemberData ||
        isErrorWorkspaceData ||
        isErrorFilespacesData ||
        isErrorWorkspaceMembers) {
        return {
            filespacesData: null,
            hasMembers: null,
            hasOnboardingPrivileges: null,
            isAuthenticated: null,
            isError: true,
            isPending: false,
            workspaceData: null,
        };
    }
    if (isPendingMemberData ||
        isPendingWorkspaceData ||
        isPendingFilespacesData ||
        isPendingWorkspaceMembers) {
        return {
            filespacesData: null,
            hasMembers: null,
            hasOnboardingPrivileges: null,
            isAuthenticated: null,
            isError: false,
            isPending: true,
            workspaceData: null,
        };
    }
    return {
        filespacesData,
        hasMembers,
        hasOnboardingPrivileges,
        isAuthenticated,
        isError: false,
        isPending: false,
        workspaceData,
    };
};
_react_refresh_temp_1(useCheckOnboarding, "j95EoQydBTTtlh3Z7apcfFqAWFc=", false, () => [useParams, useAuthProvider, useCurrentMemberByWorkspaceId, useWorkspaceByIdPoll, useFilespaceListByWorkspaceId, useMembersByWorkspaceId]);
